import { css } from 'styled-components';
import 'react-bootstrap-typeahead/css/Typeahead.css';

export default css`
  // Width
  .w-8 { width: 8% !important; }
  .w-10 { width: 10%; }
  .w-15 { width: 15%; }
  .w-20 { width: 20%; }
  .w-30 { width: 30%; }

  .adminTable-max-column {
    max-width: 5rem !important;

    &__date {
      max-width: 7rem !important;
    }

    &__status {
      max-width: 9rem !important;
    }
  }
  
  // Backgrounds
  .bg-disabled {
    background-color: ${({ theme }) => theme.palette.disabled};
  }

  .clickable:hover {
    &.clickable-text {
      color: ${({ theme }) => theme.palette.white[0]};
      background-color: ${({ theme }) => theme.palette.primary[7]};
      font-weight: 600;
    }
    box-shadow: 0 3px 3px 0 ${({ theme }) => theme.palette.grayscale[5]};
    cursor: pointer;

    &:active {
      transform: translateY(2px);
      box-shadow: none;
    }
  }
  
  .clamp {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .normal-font {
    font-size: ${({ theme }) => theme.sizes.normal} !important;
  }
  .small-font {
    font-size: ${({ theme }) => theme.sizes.small} !important;
  }
  .tiny {
    font-size: ${({ theme }) => theme.sizes.tiny} !important;
  }

  .placeholder {
    color: ${({ theme }) => theme.palette.grayscale[4]};
    font-style: italic;
  }

  .info-link-icon {
    position: absolute;
    right: 13px;
    top: -2px;

    &-select-title {
      top: -25px;
    }

    &-select {
      top: 5px;
      right: -3px;
    }

    &-checkbox {
      top: 15px;
      left: 78px;
    }

    &-lg-title {
      right: 1px;
    }

    &-left {
      top: 6px;
      left: -10px;
    }
  }

  .pop-tooltip {
    transition-delay: 0.5s;
    transition-duration: 0.3s;
  }
`;
